import Icon from '../components/Icon.vue'

Icon.register({
  syringe: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M201.5 174.8l64.9-65 135.7 135.7-181.9 181.9c-17.5 17.6-41.5 25.6-65.4 23l-63.6-7.1-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l66.4-66.4-7.1-63.6c-2.6-24.3 5.7-48.1 23-65.4l26.4-26.4 55.8 55.9c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-55.8-55.8 45.3-45.3 55.7 55.8c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3zM509.7 81.5c3.1 3.2 3.1 8.2 0 11.4l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-45.3 45.3 73.5 73.5c3.1 3.1 3.1 8.2 0 11.3l-33.9 34c-3.1 3.1-8.2 3.1-11.3 0l-17-17-135.7-135.9-17-17c-3.1-3.1-3.1-8.2 0-11.3l33.9-33.9c3.1-3.1 8.2-3.1 11.3 0l17 17 56.6 56.6 45.3-45.3-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/syringe.js
// module id = 1976
// module chunks = 0